import React from 'react';
import { List, ListItem, Divider } from '@mui/material';
import { RootState } from '../../state/store';
import { useAppSelector } from '../../state/hooks';
import { SuggestionContainer, SuggestionText } from './ResultTable.Styled';
import { SCENARIO_CREATION_DATA } from '../../utils/dataConstants';

const AudioSuggestions: React.FC = () => {
  const transcription = useAppSelector((state: RootState) => state.audio.transcription);

  const suggestions = transcription.length > 0 ? transcription : SCENARIO_CREATION_DATA.DEFAULT_SUGGESTIONS;

  return (
    <SuggestionContainer>
      <List>
        {suggestions.map((suggestion) => (
          <React.Fragment key={suggestion.id}>
            <ListItem>
              <SuggestionText>{suggestion.text}</SuggestionText>
            </ListItem>
            <Divider />
          </React.Fragment>
        ))}
      </List>
    </SuggestionContainer>
  );
};

export default AudioSuggestions;
